import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actionLogout } from "../Store/slices/AuthSlice";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionLogout());
    navigate("/login", { replace: true });
  }, [navigate, dispatch]);

  return null;
}
